
<template>
    <v-dialog persistent v-model="permissionDialog.status" max-width="300px">
    <v-card>
      <v-card-title class="overline">
        Permission Check
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-text-field v-model="permissionDialog.permission_key" label="Permission Key" type="password"></v-text-field>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn outlined color="grey" @click="cancel">Cancel</v-btn>
        <v-btn outlined color="primary" @click="permissionCheck">Submit</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'permissionDialog',
  data: () => ({
    permissionDialog: {}
  }),
  created () {
    this.permissionDialog = this.$store.state.permissionDialog
  },
  methods: {
    permissionCheck () {
      if (this.permissionDialog.permission_key === this.$store.state.joinCard.permissionToken) {
        this.$store.commit('setSnackBar',
          {
            icon: 'far fa-check-circle',
            color: 'primary',
            status: true,
            text: 'Admin mod online',
            timeout: 2000
          })
        this.permissionDialog.status = false
      } else {
        this.$store.commit('setSnackBar',
          {
            icon: 'fas fa-exclamation-circle',
            color: 'red',
            status: true,
            text: 'Wrong Permission Key',
            timeout: 2000
          })
      }
    },
    cancel () {
      this.permissionDialog.status = false
      this.$store.commit('setControlBarEditStatus', false)
      this.$store.commit('setSaveBtnStatus', false)
    }
  }
}
</script>
